<template>
  <div class="mindtab-fornitori-page">
    <accordion class="box-operation-mtab">
      <accordion-tab>
        <template #header>
          <i class="pi pi-plus-circle"></i>
          <span class="pl-1">Operazioni</span>
        </template>
        <span v-for="button in activeTabButtons" :key="button.key">
          <span v-if="isButtonVisible(button)">
            <FileUpload
              v-if="button.upload"
              :auto="true"
              :class="button.classCss"
              class="m-1"
              mode="basic"
              name="file"
              ref="file"
              :accept="button.accept"
              customUpload
              @uploader="callDynamicButtonMethod(button.method)"
              :chooseLabel="button.label"
              :chooseIcon="button.icon"
              iconPos="right"
            />
            <prime-button
              v-else-if="button.method != ''"
              :label="button.label"
              :icon="button.icon"
              :class="button.classCss"
              iconPos="right"
              class="m-1"
              @click="callDynamicButtonMethod(button.method)"
            />
          </span>
        </span>
      </accordion-tab>
    </accordion>

    <accordion class="box-filter-mtab">
      <accordion-tab>
        <template #header>
          <i class="pi pi-filter"></i>&nbsp;
          <span
            >Filtri
            <span class="num-filtri">{{ flatTableFilters.length }}</span></span
          >
        </template>

        <div class="filter-wrap p-d-flex p-flex-wrap p-ai-center p-flex-sm-row">
          <prime-button 
            v-if="flatTableFilters.length" 
            @click="cleanAllFilters" 
            label="PULISCI TUTTO" 
            icon="pi pi-ban"
            class="p-button-danger p-button-sm clean-all-btn"
          />
          <br>
          <chip
            v-for="(element, key) in flatTableFilters"
            :key="element"
            class="filter-chip"
            @remove="onFilterItemRemove({ key, element })"
            removable
          >
            {{ element.label }}
          </chip>
        </div>
      </accordion-tab>
    </accordion>

    <div class="wrapper-mindtab">
      <tab-view v-model:activeIndex="activeTabIndex" scrollable>
        <tab-panel v-for="tab in tabs" :key="tab.label">
          <template v-if="tab" #header>
            <i class="icon-tab" v-if="tab.icon" :class="tab.icon"></i>
            <span class="dynamic-font-size">{{ tab.label }}</span>
            <span class="num-tab">{{ tab.rows }}</span>
          </template>
          <keep-alive>
            <component 
              v-if="tab" 
              :is="tab.component" 
              :intialActiveTabs="activeTabList" 
              :initialFilters="filter"
              @row-fetched="(evt) => onRowFetched(evt, tab)" 
              @row-selected="tab.onRowSelected" 
              @row-filtered="tab.onRowFiltered"
              @data-searching="tab.onDataSearching"
            />
          </keep-alive>
        </tab-panel>
      </tab-view>
    </div>
  </div>
</template>

<script>
import { getCurrentInstance } from "vue";

import PrimeButton from "primevue/button";
import FattureAcquistoDataTable from "@/components/ask/tables/FattureAcquistoDataTable.vue";
import FornitoriDataTable from "@/components/ask/tables/FornitoriDataTable.vue";

import fattureAcquistoButtons from "@/config/mind-tab/tab-buttons/fatture-acquisto";
import fornitoriButtons from "@/config/mind-tab/tab-buttons/fornitori";

export default {
  name: "MindtabFornitori",

  components: {
    PrimeButton,
    FattureAcquistoDataTable,
    FornitoriDataTable,
  },

  data() {
    return {
      pageName: "MindtabFornitori",
      self: getCurrentInstance(),

      emitFilterChanged: true,
      selectedRowsByTable: {},

      filtered: {
        items: {},
        ids: {},
      },

      filter: {
        searches: {},
        items: {},
      },
      tableFilters: {},

      activeTabIndex: 0,
      tabs: [],
      user: JSON.parse(atob(localStorage.getItem("user"))).user[0],
      loader: false,
    };
  },

  computed: {
    activeTabButtons() {
      return this.tabs[this.activeTabIndex]?.buttons || [];
    },

    activeTabList() {
      return this.tabs.map((tab) => tab.name);
    },

    flatTableFilters() {
      let filters = [];
      for (let source in this.filter.items) {
        for (let filterItem of this.filter.items[source]) {
          const table = this.tabs.find(tab => tab.name === filterItem.source)?.label || filterItem.source;
          filters.push({
            table: table,
            source: filterItem.source,
            label: filterItem.label,
            value: filterItem.value,
            property: filterItem.property,
          });
        }
      }
      return filters;
    },
  },

  created() {
    const tabsConfig = [
      {
        label: "FATTURE ACQUISTO",
        icon: "pi pi-shopping-cart",
        component: "FattureAcquistoDataTable",
        name: "fattureAcquistoDataTable",
        buttons: fattureAcquistoButtons,
      },
      {
        label: "FORNITORI",
        icon: "pi pi-wallet",
        component: "FornitoriDataTable",
        name: "fornitoriDataTable",
        buttons: fornitoriButtons,
      },
    ];

    this.tabs = tabsConfig.map((el) => {
      const newEl = { ...el };
      newEl.rows = 0;

      const onRowSelectedMethod = function (evt) {
        let el = {};
        el[evt.source] = evt.items;
        this.selectedRowsByTable = { ...this.selectedRowsByTable, ...el };
      };

      const onRowFilteredMethod = function (evt) {
        let el = {};
        el[evt.filter.key] = evt.filter.items.map((element) => {
          return {
            key: evt.filter.key,
            source: evt.filter.source,
            property: element.key,
            value: element.value,
            label: element.label,
          };
        });
        this.filter.items = { ...this.filter.items, ...el };

        el = {};
        el[evt.filter.source] = evt.filter.items.map((element) => element.item);
        this.filtered.items = { ...this.filtered.items, ...el };

        el = {};
        el[evt.filter.source] = evt.filter.items.map((element) => {
          return {
            key: evt.filter.key,
            property: element.key,
            value: element.value,
          };
        });
        this.filtered.ids = { ...this.filtered.ids, ...el };
      };

      const onDataSearchingMethod = function (evt) {
        let el = {};
        const items = { ...evt.filter.items };
        items.source = evt.filter.source;
        el[evt.filter.target] = items;
        this.filter.searches = { ...this.filter.searches, ...el };
      };

      newEl.onRowSelected = onRowSelectedMethod.bind(this);
      newEl.onRowFiltered = onRowFilteredMethod.bind(this);
      newEl.onDataSearching = onDataSearchingMethod.bind(this);

      if ("buttons" in newEl && Object.keys(newEl.buttons).length != 0) {
        newEl.buttons = newEl.buttons.map((button) => {
          button.filter = newEl.name;
          return button;
        });
      }

      return newEl;
    });

    this.$eventBus.on("table-filter-changed", this.onTableFilterChanged);
    this.$eventBus.on("table-filter-removed", this.onTableFilterRemoved);
    this.$eventBus.on("clean-all-filters", this.cleanAllFilters);
  },

  mounted() {
    this.$eventBus.emit("page-change", {
      target: this,
      currentRoute: this.$router.currentRoute.value,
    });

    this.$eventBus.emit("active-tabs-changed", {
      target: this,
      tabs: this.activeTabList,
    });

    this.$nextTick(() => {
      this.$eventBus.emit("data-filter-changed", {
        target: this,
        filter: {
          searches: {},
          items: {},
        },
      });
    });
  },

  beforeUnmount() {
    this.$eventBus.off("table-filter-changed", this.onTableFilterChanged);
    this.$eventBus.off("table-filter-removed", this.onTableFilterRemoved);
    this.$eventBus.off("clean-all-filters", this.cleanAllFilters);
  },

  methods: {
    onRowFetched(evt, tab) {
      tab.rows = evt.rows || 0
      this.$forceUpdate()
    },

    callDynamicButtonMethod(methodMetadata) {
      if (typeof methodMetadata != 'string') {
        if (typeof methodMetadata.method === 'function') {
          if (methodMetadata.bindTo) {
            switch (methodMetadata.bindTo) {
              case false:
                return methodMetadata.method.apply(null, [])

              case 'this':
                if (methodMetadata.uploadFile) {
                  this.loader = true
                  Promise.all([
                    methodMetadata.method.apply(this, [this.$refs.file.files[0]])
                  ]).finally(() => {
                    this.loader = false
                  })
                  this.$refs.file.files = null;
                  return
                }
                return methodMetadata.method.apply(this, [])

              default:
                return
            }
          }

          return methodMetadata.method.apply(null, [])
        }
      }

      return
    },

    isButtonVisible(button) {
      if (button.display === "always") return true;
      if (button.display === "on-data-filtered") {
        const activeTabName = this.tabs[this.activeTabIndex].name;
        return this.filtered.items[activeTabName]?.length > 0;
      }
      return false;
    },

    onTableFilterChanged(data) {
      if (!this.tableFilters[data.table]) {
        this.tableFilters[data.table] = [];
      }

      const existingFilterIndex = this.tableFilters[data.table].findIndex(
        (filter) => filter.property === data.property
      );

      if (existingFilterIndex >= 0) {
        this.tableFilters[data.table][existingFilterIndex] = data;
      } else {
        this.tableFilters[data.table].push(data);
      }
    },

    onTableFilterRemoved(data) {
      if (this.tableFilters[data.table]) {
        this.tableFilters[data.table] = this.tableFilters[data.table].filter(
          (filter) => filter.property !== data.property
        );
      }
    },

    onFilterItemRemove(evt) {

      let filterKey = null
      let filterArray = null
      
      for (const [key, items] of Object.entries(this.filter.items)) {
        if (Array.isArray(items)) {
          const foundItem = items.find(item => 
            item.label === evt.element.label && 
            item.value === evt.element.value &&
            item.source === evt.element.source
          )
          if (foundItem) {
            filterKey = key
            filterArray = items
            break
          }
        }
      }
    
      
      if (!filterKey || !filterArray) {
        this.cleanAllFilters()
        return
      }

      if (Object.keys(this.filter.items).length > 1 || filterArray.length > 1) {
        const filterIndex = filterArray.findIndex((e) => 
          e.label === evt.element.label && 
          e.value === evt.element.value &&
          e.source === evt.element.source
        )
        if (filterIndex >= 0) {
          filterArray.splice(filterIndex, 1)
        }
      } else {
        this.cleanAllFilters()
        return
      }
      
      if (!filterArray.length) {
        delete this.filter.items[filterKey]
      }

      const newItems = {}
      Object.entries(this.filter.items).map((el) => {
        newItems[el[0]] = el[1].map((e) => e.value)
      })

      const newSearches = {}
      Object.entries(this.filter.searches || {}).map((el) => {
        newSearches[el[0]] = {
          from: el[1].from,
          to: el[1].to,
          search: el[1].search
        }
      })

      this.$eventBus.emit('data-filter-changed', {
        target: this,
        filter: {
          searches: newSearches,
          items: newItems
        }
      })
    },

    cleanAllFilters() {
      this.filter.items = {}
      this.tableFilters = {}
      this.$eventBus.emit("data-all-filter-clean")
    },
  },

  watch: {
    tabs: {
      handler: function (newVal) {
        this.$eventBus.emit("active-tabs-changed", {
          target: this,
          tabs: JSON.parse(JSON.stringify(newVal.map((el) => el.name))),
        });
      },
      deep: true,
    },

    filter: {
      handler: function (newVal) {
        this.tableFilters = {};
        Object.entries(newVal.items).map((el) => {
          const items = el[1].map((e) => {
            const table =
              this.tabs.filter((te) => {
                if (e.source === te.name) {
                  return e;
                }
              })[0]?.label || e.source;

            return {
              table,
              source: e.key,
              label: e.label,
            };
          });

          this.tableFilters[el[0]] = items;
        });

        const filterItems = Object.entries(newVal.items).reduce(
          (old, [, items]) => [...old, ...items],
          []
        );

        this.filtered.items = Object.entries(this.filtered.items)
          .map(([source, items]) => {
            return {
              [source]: items.filter(
                (x) =>
                  !!filterItems.find(
                    (y) => x[y.property] == y.value && y.source == source
                  )
              ),
            };
          })
          .reduce((acc, el) => Object.assign(acc, el), Object.create(null));

        this.filtered.ids = Object.entries(this.filtered.ids)
          .map(([source, items]) => {
            return {
              [source]: items.filter(
                (x) =>
                  !!filterItems.find(
                    (y) => x.value == y.value && y.source == source
                  )
              ),
            };
          })
          .reduce((acc, el) => Object.assign(acc, el), Object.create(null));

        const newItems = {};
        Object.entries(newVal.items).map((el) => {
          newItems[el[0]] = el[1].map((e) => e.value);
        });

        const newSearches = {};
        Object.entries(newVal.searches).map((el) => {
          newSearches[el[0]] = {
            from: el[1].from,
            to: el[1].to,
            search: el[1].search,
          };
        });

        if (this.emitFilterChanged) {
          this.$eventBus.emit("data-filter-changed", {
            target: this,
            filter: {
              searches: newSearches,
              items: newItems,
            },
          });
        } else {
          this.emitFilterChanged = true;
        }

        if (
          this.filter.searches &&
          this.filter.searches.constructor === Object &&
          Object.keys(this.filter.searches).length > 0
        ) {
          this.filter.searches = {};
          this.emitFilterChanged = false;
        }
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.mindtab-fornitori-page {
  padding: 1rem;
}

.page-header h2 {
  margin-bottom: 1.5rem;
  color: var(--text-color);
}

.box-operation-mtab,
.box-filter-mtab {
  margin-bottom: 1rem;
}

.wrapper-mindtab {
  background: var(--surface-card);
  border-radius: 6px;
  padding: 1rem;
}

.filter-wrap {
  gap: 0.5rem;
}

.clean-all-btn {
  .clean-filters {
  /* position: fixed;*/
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 10px;
  font-size: 12px;
  text-transform: uppercase;
  width: 140px;
  background-color: rgb(255, 120, 120);
  padding: 6px 12px;
  color: white;
  border-radius: 2px;
  cursor: pointer;
}
}

.filter-chip {
  background: #e9e9e9;
  color: rgb(138, 138, 138);
  font-size: 11px;
  font-weight: bold;
  padding: 2px 8px;
  border-radius: 4px;
  margin: 5px;
}

.filter-chip .p-chip-remove-icon {
  color: #dc3545 !important;
  margin-left: 0.5rem;
}

.filter-chip .p-chip-remove-icon:hover {
  color: #c82333 !important;
}

.num-filtri {
  background: var(--primary-color);
  color: white;
  border-radius: 50%;
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  margin-left: 0.5rem;
}

.icon-tab {
  margin-right: 0.5rem;
}

.num-tab {
  background: var(--surface-300);
  color: var(--text-color);
  border-radius: 12px;
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  margin-left: 0.5rem;
}

.dynamic-font-size {
  font-weight: 500;
}
</style>

